/**
 * Types partagés pour les pilotes
 */

import type { SeasonContext } from './season.js';
import {
  effectiveBonusFromChampionshipStars,
  clampChampionshipStarLevel,
  migrateLegacyStatToStars,
} from '../game/starLadder.js';

export interface Driver {
  id?: number;
  firstName: string;
  lastName: string;
  nationality: string;
  /** Image avatar publique (ex. /assets/drivers/d1/driver_d1_trello_001.jpg) */
  imagePath?: string | null;
  /** Pilotage (virage) — étoiles 1–5 */
  pilotage: number;
  /** Défense (combativité / dépassement) — étoiles 1–5 */
  defense: number;
  division?: number;
  /** Voiture attribuée par défaut (garage / saisons) — une par pilote. */
  defaultCarId?: number | null;
  /** Compte propriétaire (pilote joueur) — null = IA. */
  ownerUserId?: number | null;
}

export function driverPower(driver: Pick<Driver, 'pilotage' | 'defense'>): number {
  return (driver.pilotage ?? 0) + (driver.defense ?? 0);
}

export function effectiveCorner(
  driver: Pick<Driver, 'pilotage'>,
  season: SeasonContext = {}
): number {
  return effectiveBonusFromChampionshipStars(
    driver.pilotage ?? 0,
    season.seasonalBonusesActive !== false
  );
}

export function effectiveCombativeness(
  driver: Pick<Driver, 'defense'>,
  season: SeasonContext = {}
): number {
  return effectiveBonusFromChampionshipStars(
    driver.defense ?? 0,
    season.seasonalBonusesActive !== false
  );
}

export function clampDriverStat(v: number): number {
  return clampChampionshipStarLevel(v);
}

/** Migration depuis ancien modèle 1–5 (corner → pilotage, combativeness → defense). */
export function migrateLegacyDriverStats(legacy: {
  corner?: number;
  combativeness?: number;
  straightLine?: number;
  start?: number;
}): Pick<Driver, 'pilotage' | 'defense'> {
  const corner = legacy.corner ?? legacy.straightLine ?? 3;
  const combat = legacy.combativeness ?? 3;
  return {
    pilotage: migrateLegacyStatToStars(corner),
    defense: migrateLegacyStatToStars(combat),
  };
}
